export default __webpack_public_path__ + "static/17_35-7ee2e71058ff02982b5cadc15b714386.png";